import { PersonsDeathsService_personDeathServiceGetEntities as service } from '@festina/legalentity-general-types/legalentity/hooks/PersonsDeathsService_personDeathServiceGetEntities'

export const useFetchDeaths = service.useSuspenseQuery
